<template>
  <v-app>
    <div class="table">
      <v-text-field class="mb-4"
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          :label="'Buscar'"
          background-color="white"
          color="primary"
          clearable
          outlined
          dense
          single-line
          hide-details
      />
      <v-data-table :headers="headers"
          :items="preachings"
          :search="search"
          :sort-by="'timestamp'"
          :loading="loading"
          :locale="'es-ES'"
          sort-desc
          dense
      >
        <template v-slot:item.timestamp="{item}">
          {{ item.fecha }}
        </template>
        <template v-slot:item.actions="{item}">
          <v-tooltip color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  :disabled="!item.audioSrc"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  @click.stop="openAudio(item)"
              >
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-volume-high</v-icon>
              </v-btn>
            </template>
            <span>Escuchar predicación</span>
          </v-tooltip>
          <v-tooltip color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  :disabled="!item.youtubeId"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  @click.stop="openVideo(item)"
              >
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-youtube</v-icon>
              </v-btn>
            </template>
            <span>Ver predicación</span>
          </v-tooltip>
          <v-tooltip color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  :href="item.notasSrc"
                  target="_blank"
                  :disabled="!item.notasSrc"
              >
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-file-outline</v-icon>
              </v-btn>
            </template>
            <span>Abrir notas</span>
          </v-tooltip>
          <v-tooltip color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  :href="item.pptSrc"
                  :disabled="!item.pptSrc"
                  :download="item.pptSrc ? item.pptSrc.substring(item.pptSrc.lastIndexOf('/') + 1) : undefined"
              >
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-file-presentation-box</v-icon>
              </v-btn>
            </template>
            <span>Descargar presentación</span>
          </v-tooltip>
          <!--<v-tooltip color="primary" bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs"
                  v-on="on"
                  class="my-2 ml-1"
                  :small="!$vuetify.breakpoint.xs"
                  icon
                  :href="item.guiaSrc"
                  target="_blank"
                  :disabled="!item.guiaSrc"
              >
                <v-icon :small="!$vuetify.breakpoint.xs">mdi-navigation-variant</v-icon>
              </v-btn>
            </template>
            <span>Abrir guía para grupos pequeños</span>
          </v-tooltip>-->
          <template v-if="downloadEnabled">
            <v-tooltip color="primary" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs"
                    v-on="on"
                    class="my-2 ml-1"
                    :small="!$vuetify.breakpoint.xs"
                    icon
                    @click.stop="download(item)"
                >
                  <v-icon :small="!$vuetify.breakpoint.xs">mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Descargar</span>
            </v-tooltip>
          </template>
        </template>
      </v-data-table>
    </div>
    <v-dialog v-model="audio.show" content-class="audio-player" @input="closeAudio">
      <v-card>
        <v-card-title>{{ audio.title }}</v-card-title>
        <audio ref="audio" :src="audio.src" controls autoplay></audio>
      </v-card>
    </v-dialog>
    <v-dialog v-model="video.show" content-class="video-player" @input="closeVideo">
      <v-card>
        <v-progress-circular indeterminate color="white" :size="50" :width="4"></v-progress-circular>
        <iframe :src="video.src"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
        ></iframe>
      </v-card>
    </v-dialog>
    <v-dialog v-model="downloading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="text-center">
          <div class="pt-2 pb-1">Preparando ficheros para la descarga</div>
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  data() {
    return {
      downloadEnabled: false,
      basePath: location.origin === 'https://www.cambiosprofundos.com'
          ? `${location.origin}` : 'http://plugins.cambiosprofundos.com',
      search: null,
      headers: [
        {width: 100, text: 'Fecha', value: 'timestamp'},
        {text: 'Serie', value: 'serie'},
        {text: 'Título', value: 'titulo'},
        {text: 'Pasaje', value: 'pasaje'},
        {width: 150, text: '', value: 'actions'}
      ],
      audio: {
        show: false,
        title: null,
        src: null
      },
      video: {
        show: false,
        src: null
      },
      loading: true,
      downloading: false,
      preachings: []
    }
  },
  computed: {
    serverPath: function () {
      return `${this.basePath}/wp-content/plugins/cp-preachings/server`
    }
  },
  created() {
    axios.get(`${this.serverPath}/preachings.php`)
        .then(response => {
          this.preachings = response.data.preachings.map((preaching, i) => {
            const d = new Date(preaching.fecha)
            return {
              ...preaching,
              id: i,
              timestamp: d.getTime(),
              fecha: [d.getDate(), d.getMonth() + 1, d.getFullYear().toString().slice(-2)]
                  .map(n => n < 10 ? `0${n}` : `${n}`).join('/')
            }
          })
          this.loading = false
        })
  },
  methods: {
    openAudio(item) {
      this.audio.show = true
      this.audio.title = item.titulo
      this.audio.src = item.audioSrc
    },
    closeAudio() {
      this.audio.src = null
      this.$refs.audio.pause()
      this.$refs.audio.currentTime = 0
    },
    openVideo(item) {
      this.video.show = true
      this.video.src = `https://www.youtube.com/embed/${item.youtubeId}?rel=0&amp;controls=1&amp;showinfo=1;autoplay=1&mute=0`
    },
    closeVideo() {
      this.video.src = null
    },
    download(item) {
      this.downloading = true
      axios.post(`${this.serverPath}/download-preaching.php`, {preaching: item})
          .then((response) => {
            this.downloading = false
            if (response && response.data && response.data.path) {
              window.open(`${this.baseUrl}${response.data.path}`)
              const remove = {folder: response.data.path.split('/')[2], zipFileName: response.data.path.split('/')[3]}
              axios.post(`${this.baseUrl}/download-preaching.php`, {remove: remove})
            }
          })
    }
  }
}
</script>

<style lang="scss" scoped>
$blue-deep: #001c4a;
$blue-light: #ade0ff;

@font-face {
  font-family: 'Gotham Book';
  src: url('assets/Gotham-Book.otf');
}

@font-face {
  font-family: 'Gotham Light';
  src: url('assets/Gotham-Light.otf');
}

.v-application {
  background-color: transparent !important;
  color: $blue-deep;
  font-family: 'Gotham Book', serif;
  font-size: 0.9em;
  line-height: 1.25em;
  padding: 0;

  ::v-deep .theme--dark {
    &.v-list {
      padding: 0;
    }

    &.v-list-item {
      background-color: rgba(0, 152, 213, .5);
      font-family: 'Gotham Light', serif;

      &.v-list-item--active {
        &:not(.v-list-item--disabled) {
          color: white !important;
        }
      }
    }
  }

  ::v-deep .v-application--wrap {
    min-height: unset;
  }

  .table {
    ::v-deep button {
      border: none;
      padding: 0;

      &:hover,
      &:focus {
        background-color: inherit;
        outline: none;
      }
    }

    ::v-deep .v-input {
      .v-input__control {
        .v-input__slot {
          color: $blue-deep;

          label {
            font-weight: bold;
          }

          label,
          input,
          fieldset,
          i {
            color: $blue-deep !important;
          }

          input {
            border: none;
          }
        }
      }
    }

    ::v-deep .v-data-table {
      > .v-data-table__wrapper {
        background-color: $blue-deep;
        border: 1px solid white;

        > table {
          font-size: 1em;
          margin: 0;

          > thead {
            > tr {
              > th {
                border: none;
                font-family: 'Gotham Light', serif;
                font-size: 1.05em;
                border-bottom: 1px solid white;
                padding: 10px 16px 11px;

                &.column {
                  padding: 0;

                  .v-progress-linear {
                    color: white;

                    .v-progress-linear__background {
                      background-color: white !important;
                      border-color: white !important;
                    }
                  }
                }

                span {
                  top: 2px;
                  position: relative;
                }
              }
            }
          }

          > tbody {
            > tr {
              > td {
                background-color: rgba(0, 155, 223, 0.8);
                border: none;
                font-family: 'Gotham Light', serif;
                font-size: .9em;
                height: 36px !important;
                line-height: 16px;
                vertical-align: middle;
                -webkit-touch-callout: none; /* iOS Safari */
                -webkit-user-select: none; /* Safari */
                -moz-user-select: none; /* Old versions of Firefox */
                -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

                &:last-child {
                  padding: 0 8px;
                }
              }

              &:not(.v-data-table__empty-wrapper) {
                &:hover {
                  > td {
                    background-color: $blue-light;
                    color: $blue-deep;
                    font-weight: bold;

                    .v-btn:not(.v-btn--disabled) {
                      .v-icon {
                        color: $blue-deep !important;
                      }
                    }
                  }
                }
              }

              &.v-data-table__empty-wrapper {
                > td {
                  height: 447px !important;
                }
              }
            }
          }
        }
      }

      > .v-data-footer {
        background-color: $blue-deep;
        border-right: 1px solid white;
        border-bottom: 1px solid white;
        border-left: 1px solid white;

        .v-data-footer__select {
          .v-select {
            margin: 8px 0 8px 20px;
          }
        }
      }
    }
  }

  ::v-deep .v-dialog {
    &.video-player {
      width: auto;

      .v-card {
        width: 600px;
        position: relative;
        padding-top: 336.5px;

        iframe {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }

        .v-progress-circular {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    &.audio-player {
      width: auto;

      .v-card {
        max-width: 500px;
        padding-bottom: 1.25em;
        position: relative;
        text-align: center;

        .v-card__title {
          word-break: break-word;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .table {
      ::v-deep .v-data-table {
        > .v-data-table__wrapper {
          > table {
            > thead {
              > tr {
                > th {
                  font-family: 'Gotham Light', serif;
                  border-bottom: 1px solid white;
                  padding: 0 16px;

                  .v-select__slot {
                    label,
                    i {
                      color: white !important;
                    }

                    span {
                      top: 0;
                    }

                    .v-chip {
                      margin: 8px 0 0 0;
                    }
                  }
                }
              }
            }

            > tbody {
              > tr {
                &.v-data-table__mobile-table-row {
                  display: table-row;

                  > td {
                    &.v-data-table__mobile-row {
                      border: none;
                      min-height: 36px;
                      padding-top: 8px;
                      padding-bottom: 8px;
                      line-height: 20px;

                      .v-data-table__mobile-row__header {
                        min-width: 64px;
                      }

                      .v-data-table__mobile-row__cell {
                        text-align: left;
                        width: 100%;
                      }

                      &:last-child {
                        &.v-data-table__mobile-row {
                          border-bottom: 1px solid white;
                          padding-top: 0;

                          .v-data-table__mobile-row__header {
                            display: none;
                          }

                          .v-data-table__mobile-row__cell {
                            text-align: center;
                            width: 100%;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        .v-data-footer {
          .v-data-footer__select,
          .v-data-footer__pagination {
            margin: 0 10px;
          }
        }
      }
    }
  }
}
</style>
